export default {
  shareFilterGraphButton: "shareFilterGraphs",
  contractorForm: "contractorForm",
};
